import * as React from 'react'

import DividerComp from '../../components/DividerComp/DividerComp'
import Image from '../../components/Image/Image'
import type { ImageViewModel } from '../../view-models/ImageViewModel'
import styles from './ImageModule.css'

type Props = {
  image: ImageViewModel
}

const ImageModule = ({ image }: Props) => {
  return (
    <div className={styles.container}>
      <Image {...image} className={styles.imageWrapper} />
      <DividerComp />
    </div>
  )

}

export default ImageModule
